import {Component, OnInit} from '@angular/core';
import {FinancialChartService} from '../_services/financial-chart.service';


@Component({
    selector: 'acabim-admin-financial-tables',
    templateUrl: './financial-tables.component.html',
    styleUrls: ['./financial-tables.component.scss']
})
export class FinancialTablesComponent implements OnInit {
    index = 0;
    isLoading = false;
    tabs: any[] = [];

    selectTab($event: { index: number; }) {
        if ($event.index === 0) {
        } else {
        }
        this.index = $event.index;
    }

    constructor(private readonly financialService: FinancialChartService) {
    }

    ngOnInit(): void {
        this.isLoading = true;
        this.financialService.getAllClasses().subscribe(data => {
            this.tabs = [];
            data.forEach(accountClass => {
                this.tabs.push(accountClass.details);
            });
            this.isLoading = false;
        }, error => {
            this.isLoading = false;
        });
    }
}

